import qs from "qs";

export default (url: string = "", width = window.innerWidth) =>
  `${url}?${qs.stringify({ resize: Math.min(width * 2, 1000) })}`;
